import { Box } from "@mui/material"
import type { FC } from "react"
import { useMemo } from "react"

import { useVendorOptions } from "../../hooks/useVendorOptions"

import { AerosAutocomplete } from "@/components/UiKit/AerosAutocomplete/AerosAutocomplete"
import type { Option } from "@/types/form-fields"

interface InvoicesVendorFilterProps {
  vendorCompanyId: string | undefined
  onChange: (vendorCompanyId: string | undefined) => void
}

export const InvoicesVendorFilter: FC<InvoicesVendorFilterProps> = ({ vendorCompanyId, onChange }) => {
  const { vendors, isFetching, setSearchTerm } = useVendorOptions()

  const options = useMemo<Option<string>[]>(
    () => vendors.map((vendor) => ({ value: vendor.id, label: vendor.name })),
    [vendors]
  )

  return (
    <Box className='px-8 py-2'>
      <AerosAutocomplete<string>
        label='Vendor Name'
        placeholder='Search vendors...'
        options={options}
        value={vendorCompanyId ?? null}
        loading={isFetching}
        onChange={(value) => onChange(value ?? undefined)}
        onInputChange={setSearchTerm}
        data-testid='invoices.filter-drawer.vendor-field'
      />
    </Box>
  )
}
